import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Translator } from './translator';
import { Link } from 'react-router-dom';

const GOOGLE_STATIC_MAPS_KEY = "AIzaSyCOa-Vx3796Zb7OSqUu9qknCyKPwDY6H28";
const metaverseImages = ["/images/HomePage/METAVERSE/METAVERSE1.jpg", "/images/HomePage/METAVERSE/METAVERSE2.jpg",]; // Metaverse slider

const Home = () => {
  const [selectedInteressi, setSelectedInteressi] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [fuoriCard, setFuoriCard] = useState(null);
  const [fuoriLoading, setFuoriLoading] = useState(true);
  const [fuoriError, setFuoriError] = useState(null);
  const [isMobileLandscape, setIsMobileLandscape] = useState(false);
  const fullWrapRef = useRef(null);
  const { translateText, lang } = Translator();

  const baseTextByLang = useMemo(
    () => ({
      it: {
        text1: "Goditi l'esperienza VR",
        text2: "Goditi l'esperienza AR",
        text3: "Clicca per vedere il tour",
        text4: "Scopri le esperienze in TECHE-METAVERSE",
        text5: "Esplora ambienti 3D. Scegli il tuo AVATAR, comunica con i tuoi amici in tempo reale e gioca per scoprire le fasi di tecniche artigianali locali in un viaggio virtuale unico — dal tuo PC o dispositivo mobile Android senza muoverti da casa.",
        text6: "Scarica l'app Android Metaverse",
        text6_pc: "Scarica per PC",
        text7: "xxx",
        text8: "➔",
        text9: "Esplora la tradizione",
        text10: "Scopri luoghi straordinari da ogni angolo del mondo comodamente da casa tua.\nCon i nostri tour virtuali multimediali/immersivi, potrai esplorare città storiche, meraviglie naturali, artigianato e molto altro della Cultura Italiana.",
        text10_1: "ESPLORA LA TUA CULTURA OVUNQUE TU SIA CON IL NOSTRO SERVIZIO STREAM-IMMERSION.",
        text11: "Tour digitali pronti",
        text111: "per te",
        text12: "Filtra per",
        text13: "Interessi",
      
        text14: "Arte, Creatività e Ciak",
        text15: "Archeologia, Miti e Leggende",
        text16: "Borghi, Tradizioni e Memorie",
        text17: "Feste, Rituali e Devozione",
        text18: "Paesaggi, Cibo e Colture",
        text188: "Artigianato e Mercatini",
        text19: "Regioni",
        text20: "Campania",
        text21: "Veneto",
        text22: "Lazio",
        text23: "Puglia",
        text24: "🔇 Attiva Audio",
        text25: "🔊 Disattiva Audio",
        textabc: 'Aggiungi ai tuoi tour esperienze esclusive “Fuori Rotta”',
        text26: "“Fuori Rotta: Passeggiate Virtuali, Scorci d'Italia, Forni, Torchi e Arti” dedicate alla conoscenza e valorizzazione di particolari del Patrimonio Culturale Italiano.",
        textdef: "Con l’abbonamento, ogni 30 giorni ti attende una nuova esperienza esclusiva “Fuori Rotta”.",
        textcontent: "Nessun contenuto disponibile.",
        text27: 'Esperienza selezionata',
        text28: 'Scopri Fuori Rotta',
        text29: 'Approfondisci',
        fuoriRottaTitle: "Fuori Rotta",
        fuoriRottaSubheading: "Esplora i percorsi fuori dal comune",
        androidModalTitle: "Prima di scaricare l'app Android",
        androidModalBody: "La nostra app è affidabile e sottoposta a controlli interni di sicurezza. Se il tuo dispositivo avvisa che il file proviene da una sorgente esterna, conferma pure: il pacchetto è stato verificato. Per qualsiasi problema, contattaci su emozionartisrl@gmail.com.",
        pcModalTitle: "Prima di scaricare su PC",
        pcModalBody: "Il file è compresso in formato .rar. Dopo il download, estrailo (UnRAR/WinRAR/7-Zip) in una cartella a tua scelta e avvia l'app Metarverso 'Metaverse.exe'. In caso di avvisi dell'antivirus, consenti l'esecuzione se provieni da techetour.it. Per assistenza, scrivi a emozionartisrl@gmail.com.",
        modalCancel: "Annulla",
        modalContinue: "Continua al download",

        textScopri: "Scopri di più",
        textScopri2: "Scopri di più sugli abbonamenti",
        DisponibileAR: "Disponibile esperienza AR",
        DisponibileVR: "Disponibile esperienza VR",
        textSeeMoreTours: "Vedi altri tour",
        textBrowseAll:    "Sfoglia tutto il catalogo",


        textTitleConnect: 'Partecipa alla Community "Italiani nel Mondo"',
        textDESC: "Connettiti con altri utenti di Te.C.H-e che sono online in questo momento. Vedi chi è nelle vicinanze (posizione approssimata), invia richieste di amicizia e inizia a creare connessioni nella community.\n" +
        "Registrati per trovare amici, fare nuove conoscenze e condividere con loro la bellezza delle radici Italiane",
        textConnect: "Connettiti con altri italiani nel mondo",
        textApridPersona: "Apri la mappa delle persone",
        textApriMappa: "Apri la mappa completa",
        textAnteprima: "Anteprima mappa: utenti Te.C.H-e",
        textSeiQui: "Sei qui",
        textVistaRapida: "Vista rapida",
        textClose: "Chiudi",
      },

      en: {
        text1: "Enjoy the VR experience",
        text2: "Enjoy the AR experience",
        text3: "Click to view the tour",
        text4: "Discover experiences in TECHE-METAVERSE",
        text5:
          "Explore 3D environments. Choose your AVATAR, chat with your friends in real time and play to discover the stages of local artisan techniques in a unique virtual journey — from your PC or Android mobile device without leaving home.",
        text6: "Download the Metaverse Android app",
        text6_pc: "Download for PC",
        text7: "xxx",
        text8: "➔",
        text9: "Explore tradition",
        text10:
          "Discover extraordinary places from every corner of the world, comfortably from your home.\nWith our multimedia/immersive virtual tours, you can explore historic cities, natural wonders, craftsmanship and much more of Italian culture.",
        text10_1:
          "EXPLORE YOUR CULTURE WHEREVER YOU ARE WITH OUR STREAM-IMMERSION SERVICE.",
        text11: "Digital tours ready",
        text111: "for you",
        text12: "Filter by",
        text13: "Interests",

        text14: "Art, Creativity and Cinema",
        text15: "Archaeology, Myths and Legends",
        text16: "Villages, Traditions and Memories",
        text17: "Festivals, Rituals and Devotion",
        text18: "Landscapes, Food and Crops",
        text188: "Craftsmanship and Markets",
        text19: "Regions",
        text20: "Campania",
        text21: "Veneto",
        text22: "Lazio",
        text23: "Apulia (Puglia)",
        text24: "🔇 Turn sound on",
        text25: "🔊 Turn sound off",
        textabc: 'Add exclusive “Fuori Rotta” experiences to your tours',
        text26:
          "“Fuori Rotta: Virtual Walks, Views of Italy, Ovens, Presses and Arts” dedicated to the knowledge and promotion of unique aspects of Italian Cultural Heritage.",
        textdef:
          "With a subscription, every 30 days a new exclusive “Fuori Rotta” experience awaits you.",
        textcontent: "No content available.",
        text27: "Selected experience",
        text28: "Discover Fuori Rotta",
        text29: "Learn more",
        fuoriRottaTitle: "Fuori Rotta",
        fuoriRottaSubheading: "Explore out-of-the-ordinary paths",
        androidModalTitle: "Before downloading the Android app",
        androidModalBody:
          "Our app is reliable and has undergone internal security checks. If your device warns you that the file comes from an external source, you can safely confirm: the package has been verified. For any problem, contact us at emozionartisrl@gmail.com.",
        pcModalTitle: "Before downloading on PC",
        pcModalBody:
          "The file is compressed in .rar format. After downloading, extract it (UnRAR/WinRAR/7-Zip) into a folder of your choice and launch the Metaverse app “Metaverse.exe”. If your antivirus shows warnings, allow the execution if you are downloading from techetour.it. For assistance, write to emozionartisrl@gmail.com.",
        modalCancel: "Cancel",
        modalContinue: "Continue to download",

        textScopri: "Find out more",
        textScopri2: "Find out more about subscriptions",
        DisponibileAR: "AR experience available",
        DisponibileVR: "VR experience available",
        textSeeMoreTours: "See more tours",
        textBrowseAll: "Browse the full catalogue",

        textTitleConnect: 'Join the "Italians in the World" Community',
        textDESC:
          "Connect with other Te.C.H-e users who are online right now. See who is nearby (approximate position), send friend requests and start building connections in the community.\n" +
          "Sign up to find friends, meet new people and share with them the beauty of Italian roots.",
        textConnect: "Connect with other Italians around the world",
        textApridPersona: "Open the people map",
        textApriMappa: "Open the full map",
        textAnteprima: "Map preview: Te.C.H-e users",
        textSeiQui: "You are here",
        textVistaRapida: "Quick view",
        textClose: "Close",
      },

      fr: {
        text1: "Profitez de l’expérience VR",
        text2: "Profitez de l’expérience AR",
        text3: "Cliquez pour voir le tour",
        text4: "Découvrez les expériences dans TECHE-METAVERSE",
        text5:
          "Explorez des environnements 3D. Choisissez votre AVATAR, discutez avec vos amis en temps réel et jouez pour découvrir les étapes des techniques artisanales locales dans un voyage virtuel unique — depuis votre PC ou votre appareil mobile Android, sans quitter votre maison.",
        text6: "Télécharger l’application Metaverse pour Android",
        text6_pc: "Télécharger pour PC",
        text7: "xxx",
        text8: "➔",
        text9: "Explorez la tradition",
        text10:
          "Découvrez des lieux extraordinaires aux quatre coins du monde, confortablement depuis chez vous.\nAvec nos tours virtuels multimédias/immersifs, vous pouvez explorer des villes historiques, des merveilles naturelles, l’artisanat et bien d’autres aspects de la culture italienne.",
        text10_1:
          "EXPLOREZ VOTRE CULTURE OÙ QUE VOUS SOYEZ AVEC NOTRE SERVICE STREAM-IMMERSION.",
        text11: "Tours numériques prêts",
        text111: "pour vous",
        text12: "Filtrer par",
        text13: "Centres d’intérêt",

        text14: "Art, Créativité et Cinéma",
        text15: "Archéologie, Mythes et Légendes",
        text16: "Villages, Traditions et Mémoires",
        text17: "Fêtes, Rituels et Dévotion",
        text18: "Paysages, Cuisine et Cultures",
        text188: "Artisanat et Marchés",
        text19: "Régions",
        text20: "Campanie",
        text21: "Vénétie",
        text22: "Latium",
        text23: "Pouilles",
        text24: "🔇 Activer le son",
        text25: "🔊 Désactiver le son",
        textabc: 'Ajoutez à vos tours des expériences exclusives “Fuori Rotta”',
        text26:
          "“Fuori Rotta : Promenades virtuelles, Vues d’Italie, Fours, Presses et Arts” dédiées à la découverte et à la valorisation de détails du patrimoine culturel italien.",
        textdef:
          "Avec l’abonnement, une nouvelle expérience exclusive “Fuori Rotta” vous attend tous les 30 jours.",
        textcontent: "Aucun contenu disponible.",
        text27: "Expérience sélectionnée",
        text28: "Découvrir Fuori Rotta",
        text29: "Approfondir",
        fuoriRottaTitle: "Fuori Rotta",
        fuoriRottaSubheading: "Explorez des parcours hors des sentiers battus",
        androidModalTitle: "Avant de télécharger l’application Android",
        androidModalBody:
          "Notre application est fiable et soumise à des contrôles internes de sécurité. Si votre appareil vous avertit que le fichier provient d’une source externe, vous pouvez confirmer : le paquet a été vérifié. Pour tout problème, contactez-nous à l’adresse emozionartisrl@gmail.com.",
        pcModalTitle: "Avant de télécharger sur PC",
        pcModalBody:
          "Le fichier est compressé au format .rar. Après le téléchargement, extrayez-le (UnRAR/WinRAR/7-Zip) dans le dossier de votre choix et lancez l’application Metaverse « Metaverse.exe ». Si votre antivirus affiche des avertissements, autorisez l’exécution si vous venez de techetour.it. Pour toute aide, écrivez-nous à emozionartisrl@gmail.com.",
        modalCancel: "Annuler",
        modalContinue: "Continuer vers le téléchargement",

        textScopri: "En savoir plus",
        textScopri2: "En savoir plus sur les abonnements",
        DisponibileAR: "Expérience AR disponible",
        DisponibileVR: "Expérience VR disponible",
        textSeeMoreTours: "Voir d’autres tours",
        textBrowseAll: "Parcourir tout le catalogue",

        textTitleConnect: 'Rejoignez la communauté "Italiens dans le monde"',
        textDESC:
          "Connectez-vous avec d’autres utilisateurs Te.C.H-e actuellement en ligne. Voyez qui se trouve à proximité (position approximative), envoyez des demandes d’ami et commencez à créer des liens au sein de la communauté.\n" +
          "Inscrivez-vous pour trouver des amis, faire de nouvelles connaissances et partager avec eux la beauté des racines italiennes.",
        textConnect: "Connectez-vous avec d’autres Italiens dans le monde",
        textApridPersona: "Ouvrir la carte des personnes",
        textApriMappa: "Ouvrir la carte complète",
        textAnteprima: "Aperçu de la carte : utilisateurs Te.C.H-e",
        textSeiQui: "Vous êtes ici",
        textVistaRapida: "Aperçu rapide",
        textClose: "Fermer",
      },

      es: {
        text1: "Disfruta de la experiencia VR",
        text2: "Disfruta de la experiencia AR",
        text3: "Haz clic para ver el tour",
        text4: "Descubre experiencias en TECHE-METAVERSE",
        text5:
          "Explora entornos 3D. Elige tu AVATAR, chatea con tus amigos en tiempo real y juega para descubrir las etapas de las técnicas artesanales locales en un viaje virtual único, desde tu PC o dispositivo móvil Android sin salir de casa.",
        text6: "Descarga la aplicación Metaverse para Android",
        text6_pc: "Descargar para PC",
        text7: "xxx",
        text8: "➔",
        text9: "Explora la tradición",
        text10:
          "Descubre lugares extraordinarios desde cualquier rincón del mundo, cómodamente desde tu hogar.\nCon nuestros tours virtuales multimedia/inmersivos, puedes explorar ciudades históricas, maravillas naturales, artesanía y mucho más de la cultura italiana.",
        text10_1:
          "EXPLORA TU CULTURA DONDE QUIERAS CON NUESTRO SERVICIO STREAM-IMMERSION.",
        text11: "Tours digitales listos",
        text111: "para ti",
        text12: "Filtrar por",
        text13: "Intereses",

        text14: "Arte, Creatividad y Cine",
        text15: "Arqueología, Mitos y Leyendas",
        text16: "Pueblos, Tradiciones y Recuerdos",
        text17: "Festivales, Rituals y Devoción",
        text18: "Paisajes, Comida y Cultivos",
        text188: "Artesanía y Mercados",
        text19: "Regiones",
        text20: "Campania",
        text21: "Veneto",
        text22: "Lazio",
        text23: "Apulia (Puglia)",
        text24: "🔇 Activa el sonido",
        text25: "🔊 Desactiva el sonido",
        textabc: 'Añade experiencias exclusivas “Fuori Rotta” a tus tours',
        text26:
          "“Fuori Rotta: Paseos Virtuales, Vistas de Italia, Hornos, Prensas y Artes” dedicadas al conocimiento y promoción de aspectos únicos del Patrimonio Cultural Italiano.",
        textdef:
          "Con una suscripción, cada 30 días te espera una nueva experiencia exclusiva “Fuori Rotta”.",
        textcontent: "No hay contenido disponible.",
        text27: "Experiencia seleccionada",
        text28: "Descubre Fuori Rotta",
        text29: "Aprende más",
        fuoriRottaTitle: "Fuori Rotta",
        fuoriRottaSubheading: "Explora caminos fuera de lo común",
        androidModalTitle: "Antes de descargar la aplicación para Android",
        androidModalBody:
          "Nuestra aplicación es fiable y ha pasado controles internos de seguridad. Si tu dispositivo te advierte que el archivo proviene de una fuente externa, puedes confirmarlo con seguridad: el paquete ha sido verificado. Para cualquier problema, contáctanos en",
        pcModalTitle: "Antes de descargar en PC",
        pcModalBody:
          "El archivo está comprimido en formato .rar. Después de la descarga, extráelo (UnRAR/WinRAR/7-Zip) en una carpeta de tu elección y lanza la aplicación Metaverse “Metaverse.exe”. Si tu antivirus muestra advertencias, permite la ejecución si descargas desde techetour.it. Para asistencia, escribe a",
        modalCancel: "Cancelar",
        modalContinue: "Continuar con la descarga",

        textScopri: "Descubre más",
        textScopri2: "Descubre más sobre las suscripciones",
        DisponibileAR: "Experiencia AR disponible",
        DisponibileVR: "Experiencia VR disponible",
        textSeeMoreTours: "Ver más tours",
        textBrowseAll: "Explorar todo el catálogo",

        textTitleConnect: 'Únete a la comunidad "Italianos en el mundo"',
        textDESC:
          "Conéctate con otros usuarios de Te.C.H-e que están en línea en este momento. Ve quién está cerca (posición aproximada), envía solicitudes de amistad y comienza a crear conexiones en la comunidad.\n" +
          "Regístrate para encontrar amigos, conocer gente nueva y compartir con ellos la belleza de las raíces italianas.",
        textConnect: "Conéctate con otros italianos en el mundo",
        textApridPersona: "Abre el mapa de personas",
        textApriMappa: "Abre el mapa completo",
        textAnteprima: "Vista previa del mapa: usuarios de Te.C.H-e",
        textSeiQui: "Estás aquí",
        textVistaRapida: "Vista rápida",
        textClose: "Cerrar",
      },


    }),
    []
  );

  const activeBaseText = baseTextByLang[lang] || baseTextByLang.it;
  const [translatedText, setTranslatedText] = useState(activeBaseText);
  const [translatedCards, setTranslatedCards] = useState([]);
  const videoRef = useRef();
  const [isMuted, setIsMuted] = useState(true);
  const [showMuteButton, setShowMuteButton] = useState(true);
  const [showAndroidModal, setShowAndroidModal] = useState(false);
  const [showPcModal, setShowPcModal] = useState(false);
  const [pendingDownloadUrl, setPendingDownloadUrl] = useState(null);
  const [metaverseIndex, setMetaverseIndex] = useState(0);
  const [communityIndex, setCommunityIndex] = useState(0);
  const [userLocation, setUserLocation] = useState(null);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
      setShowMuteButton(false);
    }
  };


  useEffect(() => {
    let cancelled = false;

    // 1️⃣ For Italian / English / French → use static texts, no API
    if (lang === "it" || lang === "en" || lang === "fr") {
      setTranslatedText(baseTextByLang[lang] || baseTextByLang.it);
      return;
    }

    // 2️⃣ For ALL OTHER languages (Arabic, etc.) → use translation API from Italian
    const translateAll = async () => {
      try {
        const source = baseTextByLang.it;
        const entries = Object.entries(source);

        const translatedEntries = await Promise.all(
          entries.map(async ([key, value]) => {
            if (!value) return [key, value];
            const out = await translateText(value);
            return [key, out || value]; // fall back to Italian if empty
          })
        );

        if (!cancelled) {
          setTranslatedText(Object.fromEntries(translatedEntries));
        }
      } catch (err) {
        if (!cancelled) {
          // fallback to Italian strings on error
          setTranslatedText(baseTextByLang.it);
        }
      }
    };

    translateAll();

    return () => {
      cancelled = true;
    };
  }, [lang, translateText, baseTextByLang]);


  useEffect(() => {
    const fetchFilteredTours = async () => {
      try {
        const response = await fetch("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getAllToursByName");
        const text = await response.text();
        const raw = JSON.parse(JSON.parse(text));
        if (!Array.isArray(raw)) return;

        // helper: robust number parsing
        const toNum = (v) => {
          const n = Number(v);
          return Number.isFinite(n) ? n : NaN;
        };

        // 1) Enrich with Interessi + numeric price
        const enriched = await Promise.all(
          raw.map(async (t) => {
            try {
              const r = await fetch(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTecheTourByIDNew?nodeID=${t.id}&lang=it`);
              const j = await r.json();
              const Interessi = Array.isArray(j?.tour?.Interessi) ? j.tour.Interessi : [];
              return { ...t, Interessi, price: toNum(t.price) };
            } catch {
              return { ...t, Interessi: [], price: toNum(t.price) };
            }
          })
        );

        // 2) Apply your filters
        const filtered = enriched.filter((tour) => {
          const matchesInteressi = selectedInteressi
            ? Array.isArray(tour.Interessi) && tour.Interessi.includes(Number(selectedInteressi))
            : true;
          const matchesRegion = selectedRegion ? tour.Region === selectedRegion : true;
          return matchesInteressi && matchesRegion;
        });

        // 3) Partition: free first
        const free = filtered.filter(t => Number.isFinite(t.price) && t.price <= 0);
        const paid = filtered.filter(t => !(Number.isFinite(t.price) && t.price <= 0));
        const toBool = (v) => v === 1 || v === "1" || v === true || v === "true";
        const arvr = filtered.filter(t => toBool(t.hasAR) || toBool(t.hasVR));
        const paidNonArvr = filtered.filter(t => !(Number.isFinite(t.price) && t.price <= 0) && !(toBool(t.hasAR) || toBool(t.hasVR)));

        // Show only 3 cards
        const MAX_CARDS = 3;

        // 5) Build ordered list: [freeFirst?, arvrSecond?, …rest randomized]
        const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];
        const shuffle = (arr) => {
          const a = arr.slice();
          for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
          }
          return a;
        };

        let ordered = [];
        let usedIds = new Set();

        // First: free (if any)
        if (free.length > 0) {
          const first = pickRandom(free);
          ordered.push(first);
          usedIds.add(first.id);
        }

        // Second: AR/VR (if any left)
        const arvrCandidates = arvr.filter(t => !usedIds.has(t.id));
        if (arvrCandidates.length > 0 && ordered.length < MAX_CARDS) {
          const second = pickRandom(arvrCandidates);
          ordered.push(second);
          usedIds.add(second.id);
        }

        // Fill remaining slots from the rest (prioritize remaining AR/VR, then paid non-AR/VR, then any leftover)
        const remainingPool = shuffle([
          ...arvr.filter(t => !usedIds.has(t.id)),
          ...paidNonArvr.filter(t => !usedIds.has(t.id)),
          ...free.filter(t => !usedIds.has(t.id)),
        ]).filter(Boolean);

        for (const t of remainingPool) {
          if (ordered.length >= MAX_CARDS) break;
          ordered.push(t);
          usedIds.add(t.id);
        }

        // Edge case: if nothing matched filters, bail early
        if (ordered.length === 0) {
          setTranslatedCards([]);
          return;
        }

        // 6) Map to card view-model
        const cards = ordered.map((tour) => {
          const priceNum = Number(tour.price);
          const priceLabel =
            Number.isFinite(priceNum) && priceNum <= 0
              ? "GRATUITO"
              : (Number.isFinite(priceNum) ? `€${priceNum.toFixed(2).replace('.', ',')}` : "");

          return {
            title: tour.name || "Tour",
            subheading: tour.subheading || "",
            priceLabel,
            img: `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tour.Image}`,
            tourID: tour.id?.toString(),
            hasAR: toBool(tour.hasAR),
            hasVR: toBool(tour.hasVR),
          };
        });
        setTranslatedCards(cards);
      } catch (err) {
        console.error("Errore tours:", err);
      }
    };

    fetchFilteredTours();
  }, [lang, selectedInteressi, selectedRegion]);


  useEffect(() => {
    const fetchFuori = async () => {
      setFuoriLoading(true);
      setFuoriError(null);
      try {
        const url = `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getFuorirotta?nodeID=127981&lang=${lang}`;
        const res = await fetch(url);
        const contentType = res.headers.get("content-type") || "";
        let data;
        if (contentType.includes("application/json")) {
          data = await res.json();
        } else {
          const txt = await res.text();
          data = txt === "0" || txt === 0 ? "0" : JSON.parse(txt);
        }

        const mediaBase = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/";
        const fallbackImg = mediaBase + "Teche/placeholder.jpg";

        if (data === "0" || data === 0 || !data?.tour) {
          setFuoriCard({
            title: translatedText.fuoriRottaTitle,
            subheading: translatedText.fuoriRottaSubheading,
            imgg: fallbackImg,
            isFallback: true,
          });
          return;
        }

        const t = data.tour || {};
        const imgPath = t.copertina || t.Copertina || t.Image || null;
        const imgg = imgPath ? mediaBase + imgPath : fallbackImg;

        setFuoriCard({
          title: t.titolo_it || t.titelo_it || t.Name_it || translatedText.fuoriRottaTitle,
          subheading: t.subheading_it || t.Subheading_it || translatedText.fuoriRottaSubheading,
          imgg,
        });
      } catch (e) {
        setFuoriError(e?.message || "Errore sconosciuto");
        setFuoriCard({
          title: translatedText.fuoriRottaTitle,
          subheading: translatedText.fuoriRottaSubheading,
          imgg: "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/placeholder.jpg",
          isFallback: true,
        });
      } finally {
        setFuoriLoading(false);
      }
    };

    fetchFuori();
  }, [lang, translatedText.fuoriRottaTitle, translatedText.fuoriRottaSubheading]);



  // Detect mobile landscape and prevent scrolling
  useEffect(() => {
    let t1 = null;
    let t2 = null;

    const compute = () => {
      const isLandscape = window.matchMedia('(orientation: landscape)').matches;
      const isTouch = (('ontouchstart' in window) || navigator.maxTouchPoints > 0);
      const smallSide = Math.min(window.innerWidth, window.innerHeight) <= 640;
      setIsMobileLandscape(isLandscape && isTouch && smallSide);
    };

    const computeDeferred = () => {
      compute();
      t1 = setTimeout(compute, 100);
      t2 = setTimeout(compute, 300);
    };

    computeDeferred();
    window.addEventListener('resize', computeDeferred);
    window.addEventListener('orientationchange', computeDeferred);
    return () => {
      window.removeEventListener('resize', computeDeferred);
      window.removeEventListener('orientationchange', computeDeferred);
      if (t1) clearTimeout(t1);
      if (t2) clearTimeout(t2);
    };
  }, []);




  useEffect(() => {
  const body = document.body;
  if (isMobileLandscape) {
    // mark who locked it
    body.dataset.scrollLock = 'home-video';
    body.style.overflow = 'hidden';
  } else {
    // only unlock if *we* locked it
    if (body.dataset.scrollLock === 'home-video') {
      delete body.dataset.scrollLock;
      body.style.overflow = '';
    }
  }
  return () => {
    // cleanup on unmount or effect re-run (StrictMode safe)
    if (body.dataset.scrollLock === 'home-video') {
      delete body.dataset.scrollLock;
      body.style.overflow = '';
    }
  };
}, [isMobileLandscape]);





  const triggerDownload = (url) => {
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "");
    a.setAttribute("rel", "noopener noreferrer");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const openAndroidModal = (e) => {
    e.preventDefault();
    setPendingDownloadUrl("../MetaverseApps/Teche_Metaverse.apk");
    setShowAndroidModal(true);
  };

  const openPcModal = (e) => {
    e.preventDefault();
    setPendingDownloadUrl("../MetaverseApps/Teche_Metaverse.rar");
    setShowPcModal(true);
  };

  const confirmDownload = () => {
    if (pendingDownloadUrl) triggerDownload(pendingDownloadUrl);
    setShowAndroidModal(false);
    setShowPcModal(false);
    setPendingDownloadUrl(null);
  };

  const cancelDownload = () => {
    setShowAndroidModal(false);
    setShowPcModal(false);
    setPendingDownloadUrl(null);
  };

  // auto-slide every 5s, with cleanup (mobile + desktop safe)
  useEffect(() => {
    if (metaverseImages.length <= 1) return;
    const id = setInterval(() => {
      setMetaverseIndex((prev) => (prev + 1) % metaverseImages.length);
    }, 5000);
    return () => clearInterval(id);
  }, [metaverseImages.length]);


  // Slides for Community section: map and 2 images
  const fakePeople = useMemo(() => {
    const avatarCount = 15;

    // build 1 to 15 and shuffle -> random avatars
    const indices = Array.from({ length: avatarCount }, (_, i) => i + 1);
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [indices[i], indices[j]] = [indices[j], indices[i]];
    }

    const chosen = indices.slice(0, 5); // 5 distinct avatars on map

    // helper to generate a random position inside the map (with margin)
    const randomPos = () => {
      const margin = 15;
      const top = margin + Math.random() * (100 - margin * 2);
      const left = margin + Math.random() * (100 - margin * 2);
      return {
        top: `${top}%`,
        left: `${left}%`,
      };
    };

    // create 5 people with random avatar + random position
    return chosen.map((avatarIdx, idx) => ({
      id: idx + 1,
      ...randomPos(),
      avatar: `../images/HomePage/RandomFakeFaces/${avatarIdx}.jpg`,
    }));
  }, []);


// Map center: if userLocation exists -> use it, else fallback to Rome
const centerLat = userLocation?.lat ?? 41.9028;
const centerLng = userLocation?.lng ?? 12.4964;

// Slides for Community section: map and 2 images
const communitySlides = GOOGLE_STATIC_MAPS_KEY
  ? [
      {
        type: "map",
        src:
          `https://maps.googleapis.com/maps/api/staticmap` +
          `?center=${centerLat},${centerLng}&zoom=11&scale=2&size=640x360&maptype=roadmap` +
          `&markers=color:red|label:${translatedText.textSeiQui}|${centerLat},${centerLng}` +
          `&style=feature:poi|visibility:off` +
          `&style=feature:road|element:labels.icon|visibility:off` +
          `&key=${GOOGLE_STATIC_MAPS_KEY}`,
        alt: translatedText.textAnteprima,
      },
      {
        type: "image",
        src: "/images/HomePage/ComuunityPart/PIATTAFORMA COMMUNITY.jpg",
        alt: translatedText.textAnteprima,
      },
      {
        type: "image",
        src: "/images/HomePage/ComuunityPart/PIATTAFORMA COMMUNITY 2.jpg",
        alt: translatedText.textAnteprima,
      },
    ]
  : [
      {
        type: "image",
        src: "/images/HomePage/ComuunityPart/PIATTAFORMA COMMUNITY.jpg",
        alt: translatedText.textAnteprima,
      },
      {
        type: "image",
        src: "/images/HomePage/ComuunityPart/PIATTAFORMA COMMUNITY 2.jpg",
        alt: translatedText.textAnteprima,
      },
    ];



  // auto-slide Community teaser every 6s, with cleanup
  useEffect(() => {
    // To control if there's only 1 slide, don't bother
    if (!communitySlides || communitySlides.length <= 1) return;

    const id = setInterval(() => {
      setCommunityIndex((prev) => (prev + 1) % communitySlides.length);
    }, 6000); // 6 seconds

    return () => clearInterval(id);
  }, [communitySlides.length]);


  useEffect(() => {
    if (!("geolocation" in navigator)) {
      return; // browser does not support geolocation
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setUserLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (err) => {
        console.warn("Geolocation error or permission denied:", err);
        // keep default center (Rome) if user denies
      },
      {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 600000, // 10 minutes cache
      }
    );
  }, []);





  return (
    <div className="w-full bg-[#F2F2F2] text-black font-sans">
      {/* ===== Video Section ===== */}
      <div className="w-full">
        <div 
          ref={fullWrapRef}
          className={
          isMobileLandscape
            ? "fixed inset-0 z-50 bg-black overflow-hidden"
            : "relative z-0 w-full overflow-hidden h-[58vh] sm:h-auto sm:aspect-video lg:aspect-[1920/700]"
          }
        >

          <video
              ref={videoRef}
              className="absolute inset-0 h-full w-full object-cover object-center"
              src="../images/HomePage/Video/HomeVideo.mp4"
              preload="metadata"
              autoPlay
              muted={isMuted}
              playsInline
              controls
              poster="../images/HomePage/Video/HomeVideo_poster.jpg"
            />

              {/* CLOSE BUTTON */}
              {isMobileLandscape && (
                <button
                  onClick={() => setIsMobileLandscape(false)}
                  className="absolute top-3 right-3 bg-black/70 text-white px-3 py-1 rounded-lg text-sm z-50"
                >
                  {translatedText.textClose}
                </button>
              )}
              
            {showMuteButton && !isMobileLandscape && (
            <button
              onClick={toggleMute}
              className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black/60 text-white rounded-full px-3 py-2 text-xl z-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
            >
              {isMuted ? translatedText.text24 : translatedText.text25}
            </button>
          )}
        </div>

        {/* Explore Text */}
        <div className="relative py-16 px-4">
          <div className="w-[92%] sm:w-[85%] mx-auto text-left pr-3">
            <h1 className="font-[Montserrat] text-5xl sm:text-6xl md:text-7xl font-extrabold leading-tight break-words overflow-visible">
              {translatedText.text9}
            </h1>
            <p className="text-2xl leading-relaxed text-black pr-2">
              {translatedText.text10.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}<br />
                </React.Fragment>
              ))}
            </p>
            <p className="mt-8 text-2xl leading-relaxed text-[#007AFF] font-bold">
              {translatedText.text10_1}
            </p>
          </div>
        </div>
      </div>


      {/* ===== Cards Section ===== */}
      <div className="px-4 py-8">
        <h2 className="text-2xl text-center text-black mb-[-0.75rem]">{translatedText.text11}</h2>
        <h2 className="text-2xl text-center text-black">{translatedText.text111}</h2>

        {/* Filters */}
        <div className="flex flex-col items-center justify-center gap-4 my-8 mx-[6vw]">
          <div className="font-bold text-[1.1rem] text-center">
            {translatedText.text12}
          </div>

            <div className="grid grid-cols-2 gap-4 w-full max-w-[480px]">
              {/* Interessi */}
              <div className="relative">
                <select
                  value={selectedInteressi}
                  onChange={(e) => setSelectedInteressi(e.target.value)}
                  className="peer w-full pl-4 pr-12 py-2 rounded-md border border-gray-300 bg-white text-base cursor-pointer
                            focus:outline-none focus:ring-2 focus:ring-[#324B8E] focus:border-[#324B8E] appearance-none font-bold"
                  style={{ WebkitAppearance: 'none', MozAppearance: 'none', appearance: 'none' }}
                  aria-label={translatedText.text13}
                >
                  <option value="">{translatedText.text13}</option>
                  <option value="1">{translatedText.text14}</option>
                  <option value="2">{translatedText.text15}</option>
                  <option value="3">{translatedText.text16}</option>
                  <option value="4">{translatedText.text17}</option>
                  <option value="5">{translatedText.text18}</option>
                  <option value="6">{translatedText.text188}</option>
                </select>
                <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-black">
                  <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>

              {/* Regioni */}
              <div className="relative">
                <select
                  value={selectedRegion}
                  onChange={(e) => setSelectedRegion(e.target.value)}
                  className="peer w-full pl-4 pr-12 py-2 rounded-md border border-gray-300 bg-white text-base cursor-pointer
                            focus:outline-none focus:ring-2 focus:ring-[#324B8E] focus:border-[#324B8E] appearance-none font-bold"
                  style={{ WebkitAppearance: 'none', MozAppearance: 'none', appearance: 'none' }}
                  aria-label={translatedText.text19}
                >
                  <option value="">{translatedText.text19}</option>
                  <option value="Campania">{translatedText.text20}</option>
                  <option value="Veneto">{translatedText.text21}</option>
                  <option value="Lazio">{translatedText.text22}</option>
                  <option value="Puglia">{translatedText.text23}</option>
                </select>
                <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-black">
                  <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clipRule="evenodd" />
                  </svg>
                </div>
          </div>
        </div>
</div>
        
        {/* Cards */}
        <div className="mx-auto max-w-[1200px] px-4">
          <div className="grid gap-6 [grid-template-columns:repeat(auto-fit,minmax(240px,1fr))]">
            {translatedCards.map((card, index) => {
              const CardInner = (
                <article
                  className="
                    group relative flex h-full flex-col overflow-hidden
                    rounded-2xl border border-gray-200 bg-white
                    shadow-sm transition-all duration-300
                    hover:-translate-y-0.5 hover:shadow-lg
                    focus-within:ring-2 focus-within:ring-[#007AFF] focus-within:ring-offset-2
                  "
                  tabIndex={0}
                  aria-label={card.title}
                >
                  {/* Like bubble */}
                  <div
                    className="
                      absolute top-2 right-2 z-10
                      bg-white/90 backdrop-blur
                      rounded-full px-2 py-1 text-[18px] shadow
                      opacity-0 scale-90
                      group-hover:opacity-100 group-focus-within:opacity-100
                      group-hover:scale-100 group-focus-within:scale-100
                      transition-all duration-300
                      "
                    aria-hidden="true"
                  >
                    ❤️
                  </div>

                  {/* Image (responsive fixed heights — safest cross-browser) */}
                  <div className="relative w-full h-44 sm:h-48 md:h-52 lg:h-56 xl:h-60">
                    <img
                      src={card.img}
                      alt={`Anteprima del tour: ${card.title}`}
                      className="absolute inset-0 h-full w-full object-cover"
                      loading="lazy"
                      sizes="(min-width:1280px) 25vw, (min-width:1024px) 33vw, (min-width:640px) 50vw, 100vw"
                    />
                  </div>

                  {/* Content */}
                  <div className="flex flex-1 flex-col p-4">
                    <div className="px-1 text-center text-black">
                      <h3
                        className="
                          font-bold uppercase text-[#007AFF]
                          leading-tight
                          text-[clamp(0.95rem,2.2vw,1.1rem)]
                          break-words
                        "
                        title={card.title}
                      >
                        {card.title}
                      </h3>

                      <p
                        className="
                          mt-1 font-semibold text-gray-800
                          leading-snug
                          text-[clamp(0.9rem,1.9vw,1rem)]
                          max-h-14 overflow-hidden
                        "
                        title={card.subheading}
                      >
                        {card.subheading}
                      </p>
                    </div>

                    {/* Spacer grows, pins footer to bottom */}
                    <div className="flex-1" />

                    {/* Price & Icons */}
                    <div className="mt-3 flex items-center justify-between gap-2">
                      <p className="m-0 font-bold text-gray-900">{card.priceLabel}</p>

                      {/* Keep row height stable even if no icons */}
                      <div className="flex items-center gap-1 min-h-[34px]">
                        {card.hasVR && (
                          <img
                            src="../images/HomePage/ARVR/vr-icon.png"
                            alt={translatedText.DisponibileVR}
                            title={translatedText.text1}
                            className="h-[34px] w-[34px]"
                            loading="lazy"
                          />
                        )}
                        {card.hasAR && (
                          <img
                            src="../images/HomePage/ARVR/ar-icon.png"
                            alt={translatedText.DisponibileAR}
                            title={translatedText.text2}
                            className="h-[34px] w-[34px]"
                            loading="lazy"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </article>
              );

              return card.tourID ? (
                <Link
                  to={`/tourPreview/${card.tourID}`}
                  key={index}
                  className="block focus:outline-none"
                  title={translatedText.text3}
                >
                  {CardInner}
                </Link>
              ) : (
                <div key={index}>{CardInner}</div>
              );
            })}
          </div>
        </div>
      </div>





{/* See more tours CTA */}
{translatedCards.length > 0 && (
  <div className="mt-10 w-full flex justify-center sm:justify-end pl-4 sm:pl-[6vw] pr-6 sm:pr-[10vw]">
    <Link
      to="/choose"
      className="group relative inline-flex items-center gap-2 sm:gap-3 no-underline
                 rounded-xl px-5 sm:px-6 py-2.5 sm:py-3 font-semibold
                 bg-gradient-to-r from-[#324B8E] to-[#007AFF] text-white
                 shadow-[0_6px_16px_rgba(0,0,0,0.15)]
                 transition-all duration-300
                 hover:shadow-[0_10px_20px_rgba(0,0,0,0.25)]
                 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#007AFF]/30"
      aria-label={translatedText.textSeeMoreTours}
      title={translatedText.textBrowseAll}
    >
      <span className="text-sm sm:text-base md:text-lg font-bold tracking-wide">
        {translatedText.textSeeMoreTours}
      </span>

      {/* Arrow icon */}
      <svg
        className="w-5 h-5 translate-x-0 group-hover:translate-x-1 transition-transform duration-300"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M10.293 3.293a1 1 0 011.414 0l5 5a1 1 0 01.083 1.32l-.083.094-5 5a1 1 0 01-1.497-1.32l.083-.094L13.585 11H4a1 1 0 01-.117-1.993L4 9h9.585l-3.292-3.293a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>

      {/* Hover glow overlay */}
      <span className="pointer-events-none absolute inset-0 rounded-xl bg-white/0 group-hover:bg-white/10 transition-colors duration-300" />
    </Link>
  </div>
)}






      {/* ===== Fuori Rotta Section ===== */}
      <section className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center gap-3 flex-wrap mb-6">
            <h2 className="m-0 text-slate-900 font-extrabold tracking-tight text-2xl md:text-3xl">
              {translatedText.textabc}
            </h2>
          </div>

          {fuoriLoading ? (
            <div className="h-72 w-full animate-pulse rounded-2xl bg-gray-100" />
          ) : fuoriCard ? (
            <Link
              to={`/FuoriPreview/127981`}
              className="block overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-md hover:shadow-lg transition"
              title={translatedText.text26}
            >
              <div className="relative w-full overflow-hidden rounded-2xl">
                <div className="aspect-[2000/1414]">
                  <img
                    src={fuoriCard.imgg}
                    alt={fuoriCard.title}
                    className="absolute inset-0 w-full h-full object-cover object-center"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="p-6 text-center">
                <h3 className="text-slate-900 text-lg md:text-xl font-bold">
                  {translatedText.text26}
                </h3>
                {fuoriCard.subheading && (
                  <p className="mt-2 text-black text-base">
                    {translatedText.textdef}
                  </p>
                )}
              </div>
            </Link>
          ) : (
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-6 text-sm text-gray-700">
              {translatedText.textcontent}
            </div>
          )}
        </div>
      </section>

      {/* ===== Metaverse Experience Section ===== */}
      <div className="w-full flex flex-col md:flex-row md:justify-between items-center flex-wrap gap-8 bg-[#e6e6e6] px-[6vw] py-12 rounded-[10px] antialiased">
        <div className="flex-1 min-w-[280px]">
          <h2 className="text-[1.8rem] md:text-3xl font-bold text-black mb-4 leading-tight">
            {translatedText.text4}<br />
          </h2>
          <p className="text-base md:text-lg text-black mb-6 max-w-[500px] text-left">
            {translatedText.text5}<br />
          </p>

          {/* CTAs */}
          <div className="mt-4">
            <Link
              to="/choose?tab=abbonamento"
              className="
                group inline-flex w-full sm:w-auto items-center justify-center gap-2 no-underline
                px-6 py-3 rounded-md
                bg-[#324B8E] text-white font-bold shadow-sm
                transition-all duration-300
                hover:bg-[#293f78]
                focus-visible:outline-none focus-visible:ring-2
                focus-visible:ring-offset-2 focus-visible:ring-[#324B8E]
                active:opacity-90
              "
              aria-label={translatedText.textScopri2}
              title={translatedText.textScopri2}
            >
              <span className="text-base md:text-lg">
                {translatedText.textScopri}
              </span>
              <svg
                className="w-5 h-5 translate-x-0 group-hover:translate-x-1 transition-transform duration-300"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l5 5a1 1 0 01.083 1.32l-.083.094-5 5a1 1 0 01-1.497-1.32l.083-.094L13.585 11H4a1 1 0 01-.117-1.993L4 9h9.585l-3.292-3.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
          </div>
        </div>

        {/* Right: Metaverse slider */}
        <div className="flex justify-center items-center flex-1 min-w-[250px] px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-4">
          <div className="relative w-full max-w-[500px] sm:max-w-[600px] md:max-w-[700px] lg:max-w-[850px] xl:max-w-[1000px]">
            {/* Image */}
            <img
              src={metaverseImages[metaverseIndex]}
              alt="Esperienze nel Metaverso"
              className="w-full h-auto rounded-xl shadow-md object-contain"
              loading="lazy"
            />

            {/* Prev / Next buttons (touch-friendly) */}
            <button
              type="button"
              onClick={() =>
                setMetaverseIndex((prev) =>
                  prev === 0 ? metaverseImages.length - 1 : prev - 1
                )
              }
              className="absolute inset-y-1/2 left-2 -translate-y-1/2 rounded-full bg-black/40 text-white px-2 py-1 text-sm sm:text-base backdrop-blur-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
              aria-label="Previous image"
            >
              ‹
            </button>

            <button
              type="button"
              onClick={() =>
                setMetaverseIndex((prev) => (prev + 1) % metaverseImages.length)
              }
              className="absolute inset-y-1/2 right-2 -translate-y-1/2 rounded-full bg-black/40 text-white px-2 py-1 text-sm sm:text-base backdrop-blur-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
              aria-label="Next image"
            >
              ›
            </button>

            {/* Dots (small screens & desktop) */}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
              {metaverseImages.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => setMetaverseIndex(i)}
                  className={`h-2 w-2 rounded-full border border-white ${
                    i === metaverseIndex ? "bg-white" : "bg-black/30"
                  }`}
                  aria-label={`Go to image ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ===== Download Modals ===== */}
      {(showAndroidModal || showPcModal) && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 px-4" role="dialog" aria-modal="true">
          <div className="w-full max-w-lg rounded-xl bg-white shadow-2xl">
            <div className="border-b px-6 py-4">
              <h3 className="text-lg font-bold text-black">
                {showAndroidModal ? translatedText.androidModalTitle : translatedText.pcModalTitle}
              </h3>
            </div>

            <div className="px-6 py-5 text-sm md:text-base text-gray-800 leading-relaxed">
              {showAndroidModal ? translatedText.androidModalBody : translatedText.pcModalBody}
            </div>

            <div className="flex items-center justify-end gap-3 px-6 py-4 border-t">
              <button
                onClick={cancelDownload}
                className="px-4 py-2 rounded-lg border border-gray-300 text-black hover:bg-gray-50"
              >
                {translatedText.modalCancel}
              </button>
              <button
                onClick={confirmDownload}
                className="px-4 py-2 rounded-lg bg-[#324B8E] text-white hover:opacity-90"
              >
                {translatedText.modalContinue}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== Community/2 teaser (link to /community/2) ===== */}
      <div className="w-full flex flex-col md:flex-row items-center gap-8 bg-[#e6e6e6] px-[6vw] py-12 rounded-[10px] shadow-sm antialiased">
      {/* Left: titolo + descrizione + CTA (stile simile al blocco Metaverso) */}
      <div className="flex-1 min-w-[280px]">
        <h2 className="text-[1.8rem] md:text-3xl font-bold text-black mb-4 leading-tight">
          {translatedText.textTitleConnect}
        </h2>
        <p className="text-base md:text-lg text-black mb-6 max-w-[520px]">
          {translatedText.textDESC.split('\n').map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>

        <div className="mt-2">
          <Link
            to="/community/2"
            className="inline-flex items-center gap-2 no-underline px-6 py-3 rounded-md
                      bg-[#324B8E] text-white font-bold shadow-sm transition-colors duration-300
                      hover:bg-[#293f78] focus-visible:outline-none focus-visible:ring-2
                      focus-visible:ring-offset-2 focus-visible:ring-[#324B8E] active:opacity-90"
            aria-label={translatedText.textApridPersona}
            title={translatedText.textApridPersona}
          >
            {translatedText.textConnect}
            <svg className="w-5 h-5 translate-x-0 group-hover:translate-x-1 transition-transform duration-300" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l5 5a1 1 0 01.083 1.32l-.083.094-5 5a1 1 0 01-1.497-1.32l.083-.094L13.585 11H4a1 1 0 01-.117-1.993L4 9h9.585l-3.292-3.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </Link>
        </div>
      </div>

      {/* Right: anteprima mappa + 2 images = slider*/}
      <div className="flex justify-center items-center flex-1 min-w-[250px] px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-4">
        <Link to="/community/2" aria-label={translatedText.textApridPersona} className="block w-full">
          <div
            className="
              relative w-full
              max-w-[500px] sm:max-w-[600px] md:max-w-[700px] lg:max-w-[850px] xl:max-w-[1000px]
              rounded-xl overflow-hidden shadow-md bg-white
            "
          >
            {/* Current slide image (map or community img) */}
            <img
              src={communitySlides[communityIndex].src}
              alt={communitySlides[communityIndex].alt}
              className="w-full h-auto object-contain"
              loading="lazy"
            />

            {/* Fake people markers: only on the map slide */}
              {communitySlides[communityIndex].type === "map" && (
                <div className="pointer-events-none absolute inset-0 z-20">
                  {fakePeople.map((p) => (
                    <div
                      key={p.id}
                      className="absolute -translate-x-1/2 -translate-y-1/2"
                      style={{ top: p.top, left: p.left }}
                    >
                      <div className="h-8 w-8 sm:h-10 sm:w-10 rounded-full border-2 border-white shadow-md overflow-hidden bg-gray-200">
                        <img
                          src={p.avatar}
                          alt="Utente TecheTour"
                          className="h-full w-full object-cover"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}


            {/* overlay + hint */}
            <div className="pointer-events-none absolute inset-0 bg-black/10" />
            <div className="absolute bottom-3 right-3 rounded-lg bg-white/90 px-3 py-1 text-sm font-semibold shadow">
              {translatedText.textVistaRapida}
            </div>

            {/* Prev / Next buttons */}
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                setCommunityIndex((prev) =>
                  prev === 0 ? communitySlides.length - 1 : prev - 1
                );
              }}
              className="absolute inset-y-1/2 left-2 -translate-y-1/2 rounded-full bg-black/40 text-white px-2 py-1 text-sm sm:text-base backdrop-blur-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
              aria-label="Previous community slide"
            >
              ‹
            </button>

            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                setCommunityIndex((prev) => (prev + 1) % communitySlides.length);
              }}
              className="absolute inset-y-1/2 right-2 -translate-y-1/2 rounded-full bg-black/40 text-white px-2 py-1 text-sm sm:text-base backdrop-blur-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
              aria-label="Next community slide"
            >
              ›
            </button>

            {/* Dots */}
            <div className="absolute bottom-3 left-3 flex gap-2">
              {communitySlides.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setCommunityIndex(i);
                  }}
                  className={`h-2 w-2 rounded-full border border-white ${
                    i === communityIndex ? "bg-white" : "bg-black/30"
                  }`}
                  aria-label={`Go to community slide ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </Link>
      </div>
    </div>
  </div>
  );
};

export default Home;
